import { render, staticRenderFns } from "./category_row.vue?vue&type=template&id=5b016f34&scoped=true"
import script from "./category_row.vue?vue&type=script&lang=js"
export * from "./category_row.vue?vue&type=script&lang=js"
import style0 from "./category_row.vue?vue&type=style&index=0&id=5b016f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b016f34",
  null
  
)

export default component.exports